var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hint)?_c('div',{attrs:{"id":_vm.description}},_vm._l((_vm.formatHint),function(hint,index){return _c('p',{key:index},[_vm._v("\n    "+_vm._s(hint)+"\n  ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }